import Container, { ContainerProps } from '@mui/material/Container';
import Box, { BoxProps } from '@mui/material/Box';
import Paper, { PaperProps } from '@mui/material/Paper';
import Button, { ButtonProps } from '@mui/material/Button'
import { styled } from '@mui/material/styles';

export const StyledContainer = styled(Container)<ContainerProps>(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginBottom: theme.spacing(5),
}));

export const RequestContainer = styled(Paper)<PaperProps>(({ theme }) => ({
    marginTop: theme.spacing(5),
    padding: theme.spacing(6)
}));

export const StyledBox = styled(Box)<BoxProps>(() => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
}));

export const DeactivateButton = styled(Button)<ButtonProps>(({ theme }) => ({
    marginRight: theme.spacing(2)
}));

export const RejectButton = styled(Button)<ButtonProps>(({ theme }) => ({
    marginLeft: theme.spacing(2),
    minWidth: theme.spacing(15)
}));
